module.exports = __webpack_public_path__ + "img/thumbnail_GrizzlyBear_m_albino.5e500305.png";